export type DocumentUploadPayload = {
  isPublic?: boolean;
  customerId: string;
  investorId: string;
  docVaultCategory: string;
};

export type DocumentUploadResponse = {
  filename: string;
  message: string;
  urn: string;
}

export type InvestorAmlDocument = {
  uploadTime: string;
  filename: string;
  amlTypeCode: string;
  urn: string;
  otherTypeDescription: string;
};

export function investorAmlDocumentTransformer(row: any): InvestorAmlDocument {
  return {
    uploadTime: row.crtDate,
    filename: row.documentName,
    amlTypeCode: row.documentType,
    urn: row.documentURN,
    otherTypeDescription: row.otherTypeDescription
  };
}
